// Main entry — the ParticipantRow View (a DC over the TableRow GC) + the
// normalized Participant shape and the agent/holder adapters that produce it.
// No Container: it's a pure controlled View — a normalized Participant in,
// a row out. The QualifiedUsers DC owns the roster + navigation. Sim
// wrappers live under ./sim and are never imported here.
export { ParticipantRow, type Participant, type ParticipantRowProps } from "./ParticipantRow";
export { agentToParticipant, holderToParticipant } from "./adapters";
